import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import { Header, Sidebar } from "../../shared/layout";
import Dashboard from "./Dashboard";
import {
  CampaignManagement,
  CampaignConversionPage,
} from "../../features/campaign";
import CampaignConversionPageSimple from "../../features/campaign/CampaignConversionPageSimple";
import CampaignCreatePage from "../../features/campaign/CampaignCreatePage";
import CampaignEditPage from "../../features/campaign/CampaignEditPage";

import { RedemptionManagement } from "../../features/redemption";
import { UserManagement } from "../../features/user-management";
import { CodeManagement } from "../../features/code-management";
import {
  PartnerManagement,
  PartnerDetailPage,
} from "../../features/partners";
import { VoucherManagement } from "../../features/vouchers";

import { ErrorHandling } from "../../pages/error-handling";
import { ProfilePage } from "../../pages/profile";
import VerifyCodeTestPage from "../test/VerifyCodeTestPage";
import { authService } from "../../services/auth";

interface HomeProps {
  onLogout: () => void;
}

const Home: React.FC<HomeProps> = ({ onLogout }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Check if user should be redirected from dashboard
  useEffect(() => {
    const userRole = authService.getUserRole();
    const currentPath = location.pathname;

    // If User role tries to access dashboard, redirect to campaigns
    if (
      userRole === "User" &&
      (currentPath === "/home" || currentPath === "/home/")
    ) {
      navigate("/home/campaigns", { replace: true });
    }
  }, [location.pathname, navigate]);

  // Lấy activePage từ URL
  const getActivePageFromPath = (pathname: string) => {
    const path = pathname.replace("/home", "").replace("/", "");
    return path || "dashboard";
  };

  const activePage = getActivePageFromPath(location.pathname);

  const handlePageChange = (page: string) => {
    navigate(`/home/${page}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar
        activePage={activePage}
        onPageChange={handlePageChange}
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={setIsSidebarCollapsed}
        onLogout={onLogout}
      />
      <div
        className={`transition-all duration-300 ${
          isSidebarCollapsed ? "ml-16" : "ml-64"
        }`}
      >
        <Header onLogout={onLogout} isSidebarCollapsed={isSidebarCollapsed} />
        <main className="pt-20 p-4 dark:bg-gray-900">
          <Routes>
            <Route
              path="/"
              element={
                authService.getUserRole() === "User" ? (
                  <Navigate to="/home/campaigns" replace />
                ) : (
                  <Dashboard />
                )
              }
            />
            <Route
              path="/dashboard"
              element={
                authService.getUserRole() === "User" ? (
                  <Navigate to="/home/campaigns" replace />
                ) : (
                  <Dashboard />
                )
              }
            />
            <Route
              path="/campaigns"
              element={<CampaignManagement onPageChange={handlePageChange} />}
            />
            <Route
              path="/campaigns/create"
              element={<CampaignCreatePage onPageChange={handlePageChange} />}
            />
            <Route
              path="/campaigns/edit/:id"
              element={<CampaignEditPage onPageChange={handlePageChange} />}
            />
            <Route
              path="/campaign-conversion"
              element={<CampaignConversionPageSimple />}
            />
            <Route
              path="/user-management"
              element={
                authService.getUserRole() === "User" ? (
                  <Navigate to="/home/campaigns" replace />
                ) : (
                  <UserManagement />
                )
              }
            />
            <Route path="/redemptions" element={<RedemptionManagement />} />
            <Route
              path="/partners"
              element={<PartnerManagement onPageChange={handlePageChange} />}
            />
            <Route
              path="/partners/:id"
              element={<PartnerDetailPage onPageChange={handlePageChange} />}
            />
            <Route
              path="/vouchers"
              element={<VoucherManagement onPageChange={handlePageChange} />}
            />
            <Route
              path="/code-management"
              element={<CodeManagement onPageChange={handlePageChange} />}
            />


            <Route
              path="/error-handling"
              element={
                authService.getUserRole() === "User" ? (
                  <Navigate to="/home/campaigns" replace />
                ) : (
                  <ErrorHandling />
                )
              }
            />
            <Route
              path="/test/verify-code"
              element={
                authService.getUserRole() === "User" ? (
                  <Navigate to="/home/campaigns" replace />
                ) : (
                  <VerifyCodeTestPage />
                )
              }
            />
            <Route path="/profile" element={<ProfilePage />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default Home;
